import type { FC } from 'react';

import { Icons } from '../../../icons/iconNames';
import { NavRangeSlider, NavRangeSliderProps } from '../../navRangeSlider';

interface VolumeSliderControlPlainProps
  extends Omit<NavRangeSliderProps, 'iconOn' | 'iconOff' | 'min' | 'max' | 'step'> {}

export const VolumeSliderControlPlain: FC<VolumeSliderControlPlainProps> = ({
  value,
  onToggle,
  onDrag,
  onChange,
  ...rest
}) => {
  return (
    <NavRangeSlider
      data-testid="volume-button"
      min={0}
      max={1}
      step={0.1}
      value={value}
      iconOn={Icons.SoundOn}
      iconOff={Icons.SoundOff}
      onToggle={onToggle}
      onDrag={(newValue): void => onDrag(newValue)}
      onChange={(newValue): void => onChange(newValue)}
      {...rest}
    />
  );
};
